import React from 'react';
import clsx from 'clsx';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedProps<T extends string> {
  /** The name of the choice for a screen reader. */
  label: string;
  options: ReadonlyArray<SegmentedOption<T>>;
  value: T;
  disabled?: boolean;
  onChange: (value: T) => void;
}

/** A choice of a few values in one row (design cover-editor b1: Align, Case, the tabs of Picture). */
export function Segmented<T extends string>({
  label,
  options,
  value,
  disabled,
  onChange,
}: SegmentedProps<T>): React.ReactElement {
  return (
    <span className={styles.segmented} role="radiogroup" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          className={clsx(styles.segment, option.value === value && styles.segmentOn)}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </span>
  );
}
